import { ViewChild, Component, OnInit, Injector, EventEmitter, Output } from '@angular/core';

import { AppComponentBase } from "../../../../../shared/common/app-component-base";

import { ModalDirective } from 'ngx-bootstrap';


@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html'
})
export class BaseModalComponent extends AppComponentBase {

    @ViewChild('myappBaseModal', { static: true }) mymodal: ModalDirective;
    @Output() onYesClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onNoClick: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    customOptions = false;
    text = "";
    option1 = "";
    option2 = "";

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

  ngOnInit(): void {
  }

  show(info: string, options:string[]=[]): void {
      this.active = true;
      this.text = info;
      if (options.length !== 0) {
          this.option1 = options[0];
          this.option2 = options[1];
          this.customOptions = true;
      }
      this.mymodal.show();
  }

  close(): void {
      this.active = false;
      this.customOptions = false;
      this.mymodal.hide();
  }
  onYes(): void {
      this.active = false;
      this.mymodal.hide();
      this.onYesClick.emit();
  }
  onNo(): void {
      this.active = false;
      this.mymodal.hide();
      this.onNoClick.emit();
  }
}
